import React, { FC, memo, useMemo } from "react";

import { cn } from "../../../lib/utils.js";

import { Node, Position } from "@xyflow/react";

import { BaseNode } from "../../../../src/Components/ReactFlow/BaseNode.tsx";
import { FieldIcon } from "./FieldIcon.tsx";
import { CustomHandle } from "./CustomHandle.tsx";

import { truncate } from "../utils/index.ts";

type CustomNodeProps = Node & {
    selected: boolean;
    data: {
        fieldId: string;
        type: string;
        label: string;
        index: number;
        isFirstField: boolean;
        isLastField: boolean;
    };
};

const CustomNodeComponent: FC<CustomNodeProps> = ({
    data: { fieldId, type, label, index, isFirstField, isLastField },
    selected,
}) => {
    const TargetHandle = useMemo(() => {
        if (isFirstField || type === "welcome_screen") return null;

        return (
            <CustomHandle
                type="target"
                variant="default"
                position={Position.Left}
                onConnect={(params) => console.log("handle onConnect", params)}
                isConnectable={true}
                className="!w-0 !h-0"
            />
        );
    }, [type]);

    const SourceHandle = useMemo(() => {
        if (isLastField || type === "end_screen") return null;

        if (type === "welcome_screen") {
            return (
                <CustomHandle
                    type="source"
                    variant="default"
                    position={Position.Right}
                    isConnectable={false}
                />
            );
        }

        return (
            <CustomHandle
                type="source"
                variant="modified"
                position={Position.Right}
                onConnect={(params) => console.log("handle onConnect", params)}
                isConnectable={true}
            />
        );
    }, [type]);

    return (
        <BaseNode
            id={fieldId}
            selected={selected}
            className={cn(
                "w-[170px] h-[127px] rounded-[12px] border border-gray-200 p-4 text-left",
                selected && "!border-[#2196F3] !border-2",
            )}
        >
            {TargetHandle}
            <div>
                <FieldIcon
                    type={type}
                    index={index}
                    displayIndex={
                        type !== "welcome_screen" && type !== "end_screen"
                    }
                />
                <p className="text-sm mt-3 text-[#191B33]">
                    {truncate(label, 30)}
                </p>
            </div>
            {SourceHandle}
        </BaseNode>
    );
};

export const CustomNode = memo(CustomNodeComponent);
